<template>
	<a
		v-if="template.name === 'roster-2'"
		class="c-signee c-signee__card--template-2 component d-flex align-items-center bp-1024:align-items-flex-start bp-540:margin-y-6 text-decoration-none"
		v-bind:href="'/roster.aspx?rp_id=' + player.id"
		:aria-labelledby="'bio' + player.id"
	>
		<div
			class="c-signee__headshot flex-grow-0 flex-shrink-0 margin-6 bp-768:margin-0"
			v-bind:style="{
				'background-image':
					'url(' +
					(player.image
						? player.image + '?width=540'
						: this.$root.dark_mode
						? 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_dark.jpg'
						: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
					') ',
			}"
		></div>
		<div
			class="c-signee__details flex-grow-1 flex-shrink-1 padding-y-12 padding-x-24 d-flex flex-direction-column justify-content-center"
		>
			<div class="c-signee__details-top d-flex align-items-center">
				<div
					class="c-signee__position flex-grow-0 flex-shrink-0 font-size-16 font-weight-bold line-height-100 padding-r-6 border-r"
				>
					{{ player.position_short }}
				</div>
				<h2
					class="c-signee__name margin-0 flex-grow-1 flex-shrink-1 d-flex align-items-center padding-y-0 padding-l-6 font-size-16 font-weight-bold  line-height-100"
					:id="'bio' + player.id"
				>
					<div class="utility-text-truncate ">
						<span class="d-inline-block padding-r-4">{{
							player.first_name
						}}</span>
						<span class="d-inline-block">{{
							player.last_name
						}}</span>
					</div>
				</h2>
			</div>
			<div
				class="c-signee__details-bottom d-flex padding-t-6 font-size-14 font-weight-light"
			>
				<div
					class="c-signee__hometown flex-grow-0 flex-shrink-1 utility-text-truncate"
				>
					{{ player.hometown }}
				</div>
				<div
					class="c-signee__desc flex-grow-0 flex-shrink-0"
					v-if="player.height || player.weight"
				>
					<span class="c-signee__desc-divider padding-l-4"
						>&bull;</span
					>
					<span class="c-signee__height">
						{{
							player.weight ? player.height + ', ' : player.height
						}}
					</span>
					<span class="c-signee__weight" v-if="player.weight">
						{{ player.weight }}
					</span>
				</div>
			</div>
		</div>
	</a>
	<a
		v-else-if="template.name === 'roster-1'"
		v-bind:href="'/roster.aspx?rp_id=' + player.id"
		:aria-labelledby="'bio' + player.id"
		class="c-signee c-signee__card--template-1 component d-flex align-items-center bp-1024:align-items-flex-start  bp-540:margin-y-6 text-decoration-none"
	>
		<div
			class="c-signee__headshot flex-grow-0 flex-shrink-0 margin-6 bp-768:margin-0"
			v-bind:style="{
				'background-image':
					'url(' +
					(player.image
						? player.image + '?width=540'
						: this.$root.dark_mode
						? 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_dark.jpg'
						: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
					') ',
			}"
		></div>
		<div
			class="c-signee__details flex-grow-1 flex-shrink-1  padding-x-12 d-flex flex-direction-column justify-content-center"
		>
			<div class="c-signee__details-top d-flex align-items-center">
				<div
					class="c-signee__position flex-grow-0 flex-shrink-0 font-size-16 font-weight-bold line-height-100 padding-r-6 border-r"
				>
					{{ player.position_short }}
				</div>
				<h2
					class="c-signee__name margin-0 flex-grow-1 flex-shrink-1 utility-text-truncate  d-flex align-items-center padding-y-0 padding-l-6 font-size-16 font-weight-bold  line-height-100"
					:id="'bio' + player.id"
				>
					<div class="utility-text-truncate ">
						<span class="d-inline-block padding-r-4">{{
							player.first_name
						}}</span>
						<span class="d-inline-block">{{
							player.last_name
						}}</span>
					</div>
				</h2>
			</div>
			<div
				class="c-signee__details-bottom d-flex font-size-14 padding-t-6 font-weight-light"
			>
				<div
					class="c-signee__hometown flex-grow-0 flex-shrink-1 utility-text-truncate"
				>
					{{ player.hometown }}
				</div>
				<div
					class="c-signee__desc flex-grow-0 flex-shrink-0"
					v-if="player.height || player.weight"
				>
					<span class="c-signee__desc-divider padding-l-4"
						>&bull;</span
					>
					<span class="c-signee__height">
						{{
							player.weight ? player.height + ', ' : player.height
						}}
					</span>
					<span class="c-signee__weight" v-if="player.weight">
						{{ player.weight }}
					</span>
				</div>
			</div>
		</div>
	</a>
	<div
		v-else
		class="c-signee c-signee__card--template-3 component"
		v-bind:style="{
			'background-image':
				'url(' +
				(player.image
					? player.image + '?width=540'
					: this.$root.dark_mode
					? 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_dark.jpg'
					: 'https://s3.amazonaws.com/assets.sidearmsports.com/common/images/card-default_light.jpg') +
				') ',
		}"
	>
		<div class="c-signee__details">
			<div class="c-signee__position font-size-18 line-height-125">
				{{ player.position_short }}
			</div>
			<h2 class="c-signee__name">
				<a
					class="font-size-30 bp-540:font-size-24 bp-768:font-size-30 line-height-100"
					v-bind:href="'/roster.aspx?rp_id=' + player.id"
				>
					<div>{{ player.player_firstname }}</div>
					<div>{{ player.player_lastname }}</div>
				</a>
			</h2>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SectionRosterCard',
	props: {
		player: Object,
		template: Object,
	},
	data: () => ({}),
	methods: {},
	computed: {},
};
</script>

<style scoped lang="scss">
.c-signee__card--template-3 {
	height: 0;
	padding-bottom: 100%;
	position: relative;
	overflow: hidden;
	border: 1px solid #d9d9db;
	border-radius: 10px;
	background-size: 100%;
	background-repeat: no-repeat;
	background-position: top center;
	transition: 0.25s;
	&:before {
		content: '';
		display: block;
		bottom: 0;
		left: 0;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%);
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}
	&:hover {
		transition: 0.25s;
		background-size: 110%;
		.c-signee {
			&__position {
				&:after {
					transition: 0.25s;
					width: 30px;
				}
			}
		}
	}
	.c-signee {
		&__position {
			font-family: 'Heebo', sans-serif;
			color: #fff;
			font-weight: 300;
			padding-bottom: 15px;
			position: relative;
			&:after {
				content: '';
				display: block;
				transition: 0.25s;
				width: 24px;
				height: 3px;
				position: absolute;
				bottom: 0;
				left: 0;
				background: var(--color-primary);
			}
		}
		&__name {
			margin: 12px 0 0 0;
			a {
				text-decoration: none;
				color: #fff;
				&:hover {
					text-decoration: underline;
				}
			}
		}
		&__details {
			overflow: hidden;
			border-radius: 10px;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 2;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			padding: 12px;
		}
	}
}

.c-signee__card--template-2 {
	background: $main-color;
	box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.04);
	transition: background-color 0.2s;
	height: calc(100% - 12px);
	&:hover,
	&:focus {
		background: $color-primary;
		.c-signee {
			&__details {
				color: $text-on-primary;
			}
			&__name {
				color: $text-on-primary;
			}
		}
	}
	.c-signee {
		&__headshot {
			width: 93px;
			height: 93px;
			background: top center;
			background-size: cover;
			min-width: 1px;
		}
		&__details {
			color: $main-font-color;
			transition: color 0.2s;
			min-width: 1px;
		}
		&__position {
			min-width: 1px;
		}
		&__name {
			color: $color-safe-text;
			transition: color 0.2s;
			min-width: 1px;
			span {
				max-width: 100%;
			}
		}
		&__hometown {
			min-width: 1px;
		}
		&__desc {
			min-width: 1px;
		}
	}
	@media screen and (max-width: 767px) {
		height: auto !important;
		.c-signee {
			&__details {
				padding: 24px !important;
			}
			&__headshot {
				margin: 0 !important;
			}
		}
	}
}
.c-signee__card--template-1 {
	background: $main-color;
	box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.04);
	transition: background-color 0.2s;
	padding: 24px;
	&:hover,
	&:focus {
		background: $color-primary;
		.c-signee {
			&__details {
				color: $text-on-primary;
			}
			&__name {
				color: $text-on-primary;
			}
		}
	}
	.c-signee {
		&__headshot {
			width: 60px;
			height: 60px;
			background: top center;
			background-size: cover;
			min-width: 1px;
			border-radius: 50%;
			overflow: hidden;
		}
		&__details {
			color: $main-font-color;
			transition: color 0.2s;
			min-width: 1px;
		}
		&__position {
			min-width: 1px;
		}
		&__name {
			color: $color-safe-text;
			transition: color 0.2s;
			min-width: 1px;
			span {
				max-width: 100%;
			}
		}
		&__hometown {
			min-width: 1px;
		}
		&__desc {
			min-width: 1px;
		}
	}
}
</style>
<style lang="scss">
[data-theme='dark'] {
	.c-signee__card--template-1 {
		border: 1px solid #333;
	}
}
</style>
